module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [(_vm.$route.name === 'pages') ? _c('span', [_vm._v("\n                        Pages\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'pages') ? _c('span', [(_vm.$route.name !== 'pages') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'pages'
      }
    }
  }, [_vm._v("\n                            Pages\n                        ")]) : _vm._e(), _vm._v("\n                        →\n                        "), (_vm.$route.name === 'page') ? _c('span', [_vm._v("\n                            " + _vm._s(_vm.getPage(_vm.$route.params.id).name) + "\n                        ")]) : _c('span', [_vm._v("\n                            New Page\n                        ")])], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8e9f29e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/Pages.vue
// module id = 577
// module chunks = 0